import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const PageNotFound = (props) => {
  return (
    <div>
      <div className="container error-container container-panel">
        <div className="error-header mb-6">
          <img
            className="img-fluid"
            src="/dist/clientlibs/assets/img/404.png"
          />
        </div>
        <h4 className="error-greet">Oops, that page could not be found.</h4>
        <h5 className="error-message">
          We&apos;re sorry, the page you were looking for does not exist.
        </h5>
        <hr />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a href="/home" className="btn ps-btn--primary">
            Back to home
          </a>
        </div>
      </div>
    </div>
  );
};

PageNotFound.propTypes = {};

export default PageNotFound;
